import { DateTime } from 'luxon';
const now = (timezone) => {
    return DateTime.local().setZone(timezone ? timezone : 'Asia/Tokyo');
};
const parse = (d) => {
    return DateTime.fromISO(d, { setZone: true });
};
const parseFromFormat = (d, f) => {
    return DateTime.fromFormat(d, f);
};
const parseUnix = (u) => {
    return DateTime.fromSeconds(u);
};
const parseFromObject = (y, m, d, timezone) => {
    const timezoneOption = { zone: timezone ? timezone : 'Asia/Tokyo' };
    return DateTime.fromObject({ year: y, month: m, day: d }, timezoneOption);
};
export const getWeekDayIndex = (d) => {
    return d.weekday === 7 ? 0 : d.weekday;
};
export const getNextReservationTime = (hour, minute) => {
    if (hour === 23) {
        if (minute < 30) {
            return [`${hour}:30`, '23:55'];
        }
    }
    else if (minute < 30) {
        return [`${hour + 1}:00`, `${hour + 1}:25`];
    }
    else {
        return [`${hour + 1}:30`, `${hour + 1}:55`];
    }
    return ['', ''];
};
// https://github.com/moment/luxon/issues/118
export const getDoFormatDays = (d) => {
    const day = d.day;
    const s = ['th', 'st', 'nd', 'rd'];
    const v = day % 100;
    return day + (s[(v - 20) % 10] || s[v] || s[0]);
};
export const toJapanTime = (timestamp) => {
    return timestamp.setZone('Asia/Tokyo');
};
const dateTime = {
    now,
    parse,
    parseFromFormat,
    parseUnix,
    parseFromObject,
    getNextReservationTime,
};
export default dateTime;
